import { render } from "./OrderDetailsRightCol.vue?vue&type=template&id=554915b0&scoped=true"
import script from "./OrderDetailsRightCol.vue?vue&type=script&lang=js"
export * from "./OrderDetailsRightCol.vue?vue&type=script&lang=js"

import "./OrderDetailsRightCol.vue?vue&type=style&index=0&id=554915b0&scoped=true&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554915b0"]])

export default __exports__